import { ElementComponentProps } from "elements/types";
import { extractOnApplyParameters } from "elements/utils";
import React from "react";
import { TextAreaElement } from "records/Element";
import TextareaOnApply from "./TextareaOnApply";
import TextareaReactive from "./TextareaReactive";

function TextareaContainer(props: ElementComponentProps<TextAreaElement>) {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<TextareaOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<TextareaReactive {...props} />
	);
}

export default React.memo(TextareaContainer);
